import React, {Component} from 'react';
import {connectWithCore} from 'framework/hocs';
import {Header, Grid} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {ContentDispatch} from 'framework';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {compileContent} from 'common/utils';
import _ from 'lodash';

const MODALS = {
  VIEW: 'view',
  CREATE: 'create',
  EDIT: 'edit',
  NONE: 'none',
  DELETE: 'delete',
};

export class EditableEntityListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      openModal: MODALS.NONE,
      showModal: MODALS.NONE,
    };
  }

  toggleModal = () => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  };

  saveAction = () => {
    const {openModal} = this.state;

    const {entityDataPath, data = [], modalItem, entityType, saveEntityData} = this.props;

    let result = [];
    _.forEach(data, (row) => {
      result.push(row);
    });

    if (openModal === MODALS.CREATE) {
      result.push(modalItem);
    } else if (openModal === MODALS.EDIT) {
      result.splice(this.state.index, 1);
      result.push(modalItem);
    }
    saveEntityData(entityDataPath, entityType, result);
    this.clearEntityDataPath();
  };

  confirmAction = () => {
    this.saveAction();
    this.setState({
      isModalOpen: false,
      openModal: MODALS.NONE,
      showModal: MODALS.NONE,
    });
  };

  cancelAction = () => {
    this.setState({
      isModalOpen: false,
      openModal: MODALS.NONE,
      showModal: MODALS.NONE,
    });
    this.clearEntityDataPath();
  };

  clearEntityDataPath = () => {
    this.props.clearEntityData(
      'context.reportActionModal',
      false,
      this.props.validationId
    );
  };

  renderAddEditModal() {
    const {validationErrors, modalSize} = this.props;

    const validModalEntry = _.reduce(
      validationErrors,
      (acc, err) => acc && err.isValid,
      true
    );

    const modalContents = compileContent(this.props.modalContents);

    return (
      <FemaGoModal
        title={this.state.showModal + ' ' + this.props.modalTitle}
        open={this.state.isModalOpen}
        buttonText={this.state.showModal + ' ' + this.props.modalAction}
        disableButton={!validModalEntry}
        confirmAction={this.confirmAction}
        cancelAction={this.cancelAction}
        clearEntityData={this.clearEntityDataPath}
        size={modalSize ? modalSize : 'tiny'}
        readOnly={this.props.readOnly}
      >
        <span>
          <ContentDispatch config={modalContents} />
        </span>
      </FemaGoModal>
    );
  }

  handleAddModal = () => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
      openModal: MODALS.CREATE,
      showModal: 'Add',
    });

    this.props.saveEntityData('context.reportActionModal', this.props.entityType, {});
  };

  handleEditModal = (index, data) => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
      openModal: MODALS.EDIT,
      showModal: this.props.readOnly ? 'View' : 'Edit',
      index: index,
      ...data,
    });

    this.props.saveEntityData('context.reportActionModal', this.props.entityType, data);
  };

  handleDelete = (index, data) => {
    const {entityDataPath, entityType, saveEntityData} = this.props;
    let newData = Object.assign({}, this.props.data);
    delete newData[index];
    saveEntityData(entityDataPath, entityType, newData);
  };

  renderList = (listData) => {
    const {
      title,
      addRefTitle,
      listColumns,
      listContents,
      validationErrors,
      statusValidationIndex,
    } = this.props;
    const columns = [...listColumns];

    if (!_.isUndefined(statusValidationIndex)) {
      columns.unshift({
        id: 'statusCell',
        title: 'Status',
      });
    }

    return (
      <React.Fragment>
        <FemaGoTable type="static" summary={title}>
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              {_.map(columns, (col) => {
                return (
                  <FemaGoTable.HeaderCell key={col.id}>
                    {col.title}
                  </FemaGoTable.HeaderCell>
                );
              })}
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          {!_.isEmpty(listData) ? (
            <FemaGoTable.Body>
              {_.map(listData, (data, index) => (
                <FemaGoTable.Row key={index} background={data.removed ? 'removed' : null}>
                  {!_.isUndefined(statusValidationIndex) && (
                    <FemaGoTable.StatusCell
                      hasErrors={
                        _.get(validationErrors, `${statusValidationIndex}.isValid`, false)
                          ? false
                          : !_.get(
                              validationErrors,
                              `${statusValidationIndex}.${index}.isValid`,
                              false
                            )
                      }
                      float={'left'}
                      cellID={`Row ${index + 1}`}
                    />
                  )}
                  {_.map(listContents, (col) => {
                    return (
                      <FemaGoTable.TextCell key={col.id}>
                        {compileContent(col.value, {data})}
                      </FemaGoTable.TextCell>
                    );
                  })}
                  <FemaGoTable.TextCell>
                    <a
                      href="#"
                      title={this.props.readOnly ? 'View' : 'Edit'}
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleEditModal(index, data);
                      }}
                    >
                      {this.props.readOnly ? 'View' : 'Edit'}
                    </a>
                  </FemaGoTable.TextCell>
                  {!this.props.readOnly && (
                    <FemaGoTable.TextCell>
                      <a
                        href="#"
                        title="Remove"
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleDelete(index, data);
                        }}
                      >
                        {'Remove'}
                      </a>
                    </FemaGoTable.TextCell>
                  )}
                </FemaGoTable.Row>
              ))}
            </FemaGoTable.Body>
          ) : (
            <FemaGoTable.Body>
              <FemaGoTable.TextCell>
                {<div className={`errorMessages`}>{this.props.emptyListMessage}</div>}
              </FemaGoTable.TextCell>
            </FemaGoTable.Body>
          )}
        </FemaGoTable>
        {!this.props.readOnly && (
          <Grid.Column width={10}>
            <a href="#" title={addRefTitle} onClick={() => this.handleAddModal()}>
              + {addRefTitle}{' '}
            </a>
          </Grid.Column>
        )}
      </React.Fragment>
    );
  };

  render() {
    const {data = [], header, headerClasses, headerSize} = this.props;

    return (
      <React.Fragment>
        {header !== undefined && (
          <Header
            as={headerSize || 'h4'}
            className={headerClasses || ''}
            content={compileContent(header, this.props)}
          />
        )}
        {this.renderList(data)}
        {this.renderAddEditModal()}
      </React.Fragment>
    );
  }
}

export default connectWithCore(EditableEntityListTable);
